import { E_ShareholderStatuses } from '@/enums'
import { RUBLE } from './consts'
export { CACHE_BUSTER } from './consts'
export { getMs, getSec } from './time-utils'


//
// Проверка на платформу
//

export const isAndroid = typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent)
export const isIOS = typeof navigator !== 'undefined' && (/iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
export const isCordova = typeof window !== 'undefined' && !!(window as any).cordova
export const isCordovaBuild = import.meta.env.VITE_IS_CORDOVA === true
export const isCordovaApp = isCordovaBuild || isCordova

export const isDesktop = typeof navigator !== 'undefined' &&
  /windows|macintosh|mac os|linux/i.test(navigator.userAgent) &&
  !/android/i.test(navigator.userAgent)


//
// Аккаунты для тестирования
//

export const accountsForTesting = [
  1042, // Н
  1044, // C
  1045, // И
  1051, // В
  1053, // Р
]

//
// Make first letter big: 'text' -> 'Text'
//
export const capitalizeText = (s: string) => {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

//
// Is number
//
export const isNumber = (x: string) => Number.isInteger(Number(x))

//
// Format number
//
const formatNumber = (num: number, withKopecks = false) => {
  const options: Intl.NumberFormatOptions = {
    useGrouping: true,
  }

  if (withKopecks) {
    options.minimumFractionDigits = 2
    options.maximumFractionDigits = 2
  }

  return new Intl.NumberFormat('ru-RU', options).format(num)
}

//
// Format money
//
export const formatMoney = (
  num: number,
  isConvertToRubFromCents: boolean = false,
  isHideRubleSymbol: boolean = false,
  withKopecks: boolean = false,
) => {
  if (isConvertToRubFromCents) {
    return `${formatNumber(
      Number(num) / 100,
      withKopecks,
    )} ${!isHideRubleSymbol ? RUBLE : ''}`
  }

  return `${formatNumber(num, withKopecks)} ${!isHideRubleSymbol ? RUBLE : ''}`
}


//
// Convert HEX color format to RGBA
//

export const hexToRgba = (hex: string, alpha: number) => {
  const [ r, g, b ] = hex.replace('#', '')
    .match(/.{1,2}/g)!
    .map((c) => parseInt(c, 16))

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}


export const cleanUpPhone = (
  phone: string,
  withoutPlus?: boolean,
) => (
  withoutPlus
    ? phone.replace(/[^\d]/g, '')
    : phone.replace(/[^\d+]/g, '')
)

// export const cleanUpPhone = (
//   phone: string,
//   withoutPlus?: boolean,
// ) => {
//   const digits = phone.replace(/[^\d]/g, '')

//   // Если номер начинается с 89... или 79... (11 цифр), заменяем первую цифру на 7
//   if (digits.length === 11 && (digits.startsWith('8') || digits.startsWith('7'))) {
//     return (withoutPlus ? '' : '+') + '7' + digits.slice(1)
//   }

//   // Если номер 10 цифр (9...), добавляем +7
//   if (digits.length === 10) {
//     return (withoutPlus ? '' : '+') + '7' + digits
//   }

//   // Иначе возвращаем как есть (с плюсом или без)
//   return (withoutPlus ? '' : '+') + digits
// }

//
// Format timestamp
//
export const formatTs = (ts?: number) => {
  if (!ts) return ''

  const d = new Date(ts)
  const pad = (n: number) => String(n).padStart(2, '0')

  return `${
    pad(d.getDate())
  }.${
    pad(d.getMonth() + 1)
  }.${
    d.getFullYear()
  } ${
    pad(d.getHours())
  }:${
    pad(d.getMinutes())
  }`
}



export const getShareholderStatusText = (status: E_ShareholderStatuses | number): string => {
  switch (status) {

  case E_ShareholderStatuses.None:
    return 'Только зарегистрировался'
  case E_ShareholderStatuses.Want:
    return 'Заполнил и отправил форму'
  case E_ShareholderStatuses.Waiting:
    return 'Ожидает подтверждения'
  case E_ShareholderStatuses.Shareholder:
    return 'Пайщик'
  case E_ShareholderStatuses.Subscription1:
    return 'Тариф №1'
  case E_ShareholderStatuses.Subscription2:
    return 'Тариф №2'
  case E_ShareholderStatuses.Subscription3:
    return 'Тариф №3'
  default:
    return 'Неизвестный статус'

  }
}
